import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
  BasePageMetaResolver,
  BaseSiteService,
  CanonicalPageResolver,
  PageDescriptionResolver,
  PageMetaResolver,
  PageRobotsMeta,
  PageRobotsResolver,
  PageTitleResolver,
  PageType
} from '@spartacus/core';
import { combineLatest, Observable } from 'rxjs';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';
import { Recipe } from '../../models';
import { RecipeService } from '../../services';

@Injectable({ providedIn: 'root' })
export class RecipePageMetaResolver
  extends PageMetaResolver
  implements PageTitleResolver, PageDescriptionResolver, PageRobotsResolver, CanonicalPageResolver
{
  private recipe$: Observable<Recipe>;

  constructor(
    protected basePageMetaResolver: BasePageMetaResolver,
    private recipeService: RecipeService,
    private baseSiteService: BaseSiteService,
    private route: ActivatedRoute
  ) {
    super();
    this.pageType = PageType.CONTENT_PAGE;
    this.pageTemplate = 'RecipeDetailsPageTemplate';
  }

  resolveTitle(): Observable<string> {
    this.recipe$ = this.route.firstChild?.firstChild?.paramMap?.pipe(
      switchMap((paramMap) =>
        this.recipeService.getFirstRecipeVariant(
          paramMap.get('sourceSystem'),
          decodeURIComponent(paramMap.get('recipeId'))
        )
      )
    );
    return combineLatest([this.basePageMetaResolver.resolveTitle(), this.recipe$]).pipe(
      map(([title, recipe]) =>
        title
          .replace(/<recipe.title>/gi, recipe.title)
          .replace(/<page>/gi, '')
          .replace(/<recipe.appliance>/gi, recipe.defaultApplianceGroup?.name)
      )
    );
  }

  resolveDescription(): Observable<string> {
    return this.basePageMetaResolver.resolveDescription();
  }

  resolveRobots(): Observable<PageRobotsMeta[]> {
    return this.basePageMetaResolver.resolveRobots().pipe(
      withLatestFrom(this.baseSiteService.getActive()),
      map(([robots, activeBaseSite]) => {
        if (
          this.route.snapshot.queryParamMap.has('recipeId') &&
          !['Moulinex-FR', 'Tefal-FR'].includes(activeBaseSite)
        ) {
          return [PageRobotsMeta.NOINDEX];
        }
        return robots;
      })
    );
  }

  resolveCanonicalUrl(): Observable<string> {
    return this.basePageMetaResolver.resolveCanonicalUrl();
  }
}
